import { RouteObject } from "react-router-dom";
import SettingsLanding from "./landing/landing";
import SegmentCreation from "./tabs/segment/create/create";

export interface uxSettingsRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: uxSettingsRoute[];
}

export const uxSettingsRoutes: uxSettingsRoute[] = [
  {
    path: "communication-hub/settings",
    element: <SettingsLanding />,
  },
  {
    path: "communication-hub/settings/segment/:action",
    element: <SegmentCreation />,
  },
  {
    path: "communication-hub/settings/segment/:action/:id",
    element: <SegmentCreation />,
  },
];
